import { useRef } from 'react';
import { usePathname, useRouter } from 'expo-router';
import { useChatInputStore } from '@/store/chatInput';
import { useArtifactViewerStore } from '@/store/artifactViewer';

// Artifact studios also open outside conversations, such as the Files library.
// Resolve the attachment first; only create a draft when it is ready to hand off.
export default function useArtifactEditConversation() {
  const pathname = usePathname();
  const router = useRouter();
  const pathnameRef = useRef(pathname);
  pathnameRef.current = pathname;

  const captureTarget = () => ({ pathname: pathnameRef.current, contextId: useChatInputStore.getState().currentContextId });
  const assertTarget = target => {
    if (pathnameRef.current !== target.pathname || useChatInputStore.getState().currentContextId !== target.contextId) {
      throw new Error('The active chat changed. Please try again in the intended chat.');
    }
  };
  const addRequest = (target, { file, prompt, mode }) => {
    assertTarget(target);
    const startNew = !target.contextId || /^\/files(?:\/|$)/.test(target.pathname || '');
    if (startNew) useChatInputStore.getState().initializeNewChatWithFiles([]);
    const composer = useChatInputStore.getState();
    const contextId = composer.currentContextId;
    const existing = composer.inputStates[contextId]?.text?.trim();
    if (file) composer.addFile(file);
    composer.setText(existing ? `${existing}\n\n${prompt}` : prompt);
    composer.requestInputFocus(contextId);
    if (startNew) {
      if (mode === 'coworker') require('@/store/coworker').useCoworkerStore.getState().setComposerMode('coworker');
      useArtifactViewerStore.getState().closeArtifactViewer();
      router.push('/app');
    }
    return contextId;
  };

  return { captureTarget, assertTarget, addRequest };
}
